var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bookmark-button",on:{"click":_vm.toggleBookmark}},[(!_vm.hasBookmark)?_c('icon',{attrs:{"name":"star"}}):_c('icon',{attrs:{"name":"star-filled"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }